module.exports = __webpack_public_path__ + "img/icon-tent.2688ce8d.png";